module.exports = __webpack_public_path__ + "img/backuser.0864c6a9.svg";